export const defaultHiredInsuranceStatusProps = {
  ['pending']: { bgColor: 'bg-warning-600', label: 'Pendente' },
  ['approved']: { bgColor: 'bg-feedback-success-main', label: 'Contratado' },
  ['canceled']: { bgColor: 'bg-feedback-error-main', label: 'Cancelado' },
};

export enum HiredInsuranceProductType {
  MARISA_TAKES_CARE = 'R1669',
  MARISA_AUTO = '9876',
  BAG_PROTECTION = '7112',
  INCOME_PROTECTION = '1606',
}

export interface HiredInsuranceVehicle {
  plate: string;
  manufacturer: string;
  model: string;
  yearModel: number;
  manufactureYear: number;
}

export interface HiresInsurancePlanDetail {
  description: string;
  value: string;
}

export interface HiredInsurancePlan {
  name: string;
  description: string;
  fipeValue: number;
  franchiseValue: string;
  details: HiresInsurancePlanDetail[];
}

export type InsuranceStatus = 'pending' | 'approved';

export interface ContractedService {
  holderName?: string;
  policyNumber: string;
  policyUrl: string | null;
  certificateCode: string;
  productCode: HiredInsuranceProductType;
  productName: string;
  productDescription: string;
  saleDate: string;
  vehicle: HiredInsuranceVehicle | null;
  plan: HiredInsurancePlan | null;
  validity: number;
  value: number;
  luckyNumber?: string;
  insuranceCompanyName: string | null;
  chosenPaymentMethod: string | null;
  chosenInstallmentQuantity: number | null;
  chosenInstallmentValue: number | null;
  status?: InsuranceStatus;
  cancellationDate: string | null;
}
